import { useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Props_SnippetHoverCard } from "./HoverCard.props";
import { Navigation, Pagination } from "swiper/modules";
import { CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";

const SnippetHoverCard = (props: Props_SnippetHoverCard) => {
    const { heading, repeatable_card } = props;
    const [openCard, setOpenCard] = useState<number | null>(null);

    const snippetIDRef = useRef<string>(
        Math.random().toString(36).substring(2, 10)
    );
    const snippetID = snippetIDRef.current;
    const classHeadingVisibility: string = heading.visibility.value
        ? `snippet-hover-card__heading--${heading.visibility.value}`
        : "";

    const toggleCard = (index: number) => {
        setOpenCard(openCard === index ? null : index);
    };

    return (
        <section className="snippet-hover-card">
            <div className="snippet-hover-card__container">
                {heading?.content?.value && (
                    <h2
                        id={`snippet-hover-card-${snippetID}`}
                        className={`snippet-hover-card__heading ${classHeadingVisibility}`}
                    >
                        {heading.content.value}
                    </h2>
                )}
                
                <div className="snippet-hover-card__grid">
                    {/* Swiper integration */}
                    <Swiper
                        spaceBetween={17}
                        breakpoints={{
                            0: { slidesPerView: 1 },
                            768: { slidesPerView: 2 },
                            998: { slidesPerView: 3 },
                        }}
                        modules={[Navigation, Pagination]}
                        navigation={{
                            nextEl: ".swiper-navigation__button-next",
                            prevEl: ".swiper-navigation__button-prev",
                        }}
                        pagination={{ 
                            clickable: true,
                            el: `.snippet-hover-card__pagination-container`,
                            bulletClass: 'swiper-pagination-bullet',
                            bulletActiveClass: 'swiper-pagination-bullet-active',
                            dynamicBullets: false,
                            dynamicMainBullets: 1
                        }}

                    >
                        {repeatable_card.map((card, index) => {
                            const {
                                image,
                                alt,
                                heading: cardHeading,
                                content,
                                linkText,
                                linkHref,
                                linkStyle,
                                linkTarget,
                            } = card;
                            const isOpen = openCard === index;
                            return (
                                <SwiperSlide
                                    key={`snippet-hover-card-${snippetID}-${index}`}
                                >
                                    <article
                                        className={`snippet-hover-card__item ${isOpen ? "snippet-hover-card__item--open" : ""}`}
                                    >
                                        <div className="snippet-hover-card__image-container">
                                            {image?.value && (
                                                <img
                                                    src={image.value}
                                                    alt={alt?.value || ""}
                                                    className="snippet-hover-card__image"
                                                />
                                            )}
                                        </div>
                                        <div
                                            className="snippet-hover-card__content"
                                            aria-expanded={isOpen}
                                        >
                                            {cardHeading?.value && (
                                                <div className="snippet-hover-card__heading-section">
                                                    <h3 className="snippet-hover-card__card-heading">
                                                        {cardHeading.value}
                                                    </h3>
                                                    <button
                                                        className={`snippet-hover-card__button ${linkStyle?.value || "primary"}`}
                                                        aria-label={`${isOpen ? "Close" : "Open"} ${cardHeading.value} details`}
                                                        onClick={() =>
                                                            toggleCard(index)
                                                        }
                                                        aria-expanded={isOpen}
                                                    ></button>
                                                </div>
                                            )}
                                            {content?.value && (
                                                <div className="snippet-hover-card__text">
                                                    <div>{CompileMarkdown(content.value)}</div>
                                                </div>
                                            )}
                                            {linkText?.value &&
                                                linkHref?.value && (
                                                    <a
                                                        className="snippet-hover-card__link"
                                                        href={linkHref.value}
                                                        target={
                                                            linkTarget?.value === "true"
                                                                ? "_blank"
                                                                : "_self"
                                                        }
                                                        rel={
                                                            linkTarget?.value === "true"
                                                                ? "noopener noreferrer"
                                                                : undefined
                                                        }
                                                        aria-label={`${linkText.value} for ${cardHeading?.value || "this card"}`}
                                                    >
                                                        {linkText.value
                                                            .charAt(0)
                                                            .toUpperCase()}
                                                    </a>
                                                )}
                                        </div>
                                    </article>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
                <div className="snippet-hover-card__button-container swiper-navigation">
                    <button
                        className=" snippet-hover-card__button-prev swiper-navigation__button-prev"
                        aria-label="{{js.swiper.navigation.slide.prev.aria-label}}"
                    ></button>
                     <nav className="snippet-hover-card__pagination-container swiper-pagination"></nav>
                    <button
                        className=" snippet-hover-card__button-next swiper-navigation__button-next"
                        aria-label="{{js.swiper.navigation.slide.next.aria-label}}"
                    ></button>
                </div>
            </div>
        </section>
    );
};

export default SnippetHoverCard;
